module.exports = __webpack_public_path__ + "static/media/jingpin1.edd4c8c1.jpg";